import React from "react"
import StyledDiv from "./styles"
import { StopMarker } from "../StopMarker"
import { Color } from "../../models"
import { appsStyleSelected } from "../../helpers/app"

interface IProps {
  horizontal: boolean
  colorStart: Color
  colorEnd: Color
}

export const StopsRouteDots: React.FC<IProps> = ({ horizontal, colorStart, colorEnd }) => {
  return (
    <StyledDiv className={`${appsStyleSelected?.style}`} style={{ flexDirection: horizontal ? 'row' : 'column' }}>
      <StopMarker color={ colorStart } />
      <div className={`line-${horizontal ? 'horizontal' : 'vertical'}`} style={{
        background: `linear-gradient(to ${horizontal ? 'right' : 'bottom'}, ${colorStart}, ${colorEnd})`
      }}></div>
      <StopMarker color={ colorEnd } />
    </StyledDiv>
  )
}

